 /* eslint-disable */
import React, { useState, useEffect} from 'react'
import Products from './Products'
import AddProduct from './AddProduct'
import { getProductsByUser } from '../../actions/productActions'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import NoData from '../svgIcons/NoData'
import Spinner from '../Spinner/Spinner'
import useAuthUser from '../../hooks/useAuthUser'


const ProductList = () => {

    const history = useHistory()
    const location = useLocation()
    const [open, setOpen] = useState(false)
    const [currentId, setCurrentId] = useState(null)
    const dispatch = useDispatch()
    const authData = useAuthUser()
    const {products} = useSelector((state) => state.products)
    const isLoading = useSelector(state => state.products.isLoading)
    const focusModel = React.useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.get('focus') || '';
    }, [location.search]);
    // const products = []

    
    // useEffect(() => {
    // }, [currentId, dispatch]);
    
//     useEffect(() => {
//         dispatch(getProducts(1));
//         // dispatch(getProductsByUser({userId : user?.result?._id}));
//         // dispatch(getProductsByUser({ search :user?.result?._id, tags: tags.join(',') }));
//     },[location]
// )

useEffect(() => {
    const userId = authData?.result?._id || authData?.result?.googleId
    if (userId) {
        dispatch(getProductsByUser({ search: userId }));
    }
  },[location, dispatch, authData])

  if(!authData) {
    history.push('/login')
  }

  
  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

    return (
        <div>
            <AddProduct 
                open={open} 
                setOpen={setOpen}
                currentId={currentId}
                setCurrentId={setCurrentId}
            />
            <Products 
                open={open} 
                setOpen={setOpen}
                currentId={currentId}
                setCurrentId={setCurrentId}
                products={products}
                focusModel={focusModel}
            />
        </div>
    )
}

export default ProductList
